import { useEffect, useState } from "react";
import { api } from "../api";
import { link } from "../App";
import { errorText, useT } from "../i18n";
import { useQueryParam } from "../router";
import { useSession } from "../session";

/**
 * A request to connect (PLAN.md 4.16 K8): another member invited this member's address. Accepting
 * makes both follow each other; declining closes it, and the inviter only sees an expired invite.
 */
export function Connect() {
  const t = useT();
  const { refresh } = useSession();
  const code = useQueryParam("code") ?? "";
  const [inviter, setInviter] = useState<{ id: number; display_name: string } | null | undefined>(undefined);
  const [done, setDone] = useState<"accepted" | "declined" | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api.connectInfo(code).then((r) => setInviter(r.inviter), () => setInviter(null));
  }, [code]);

  async function answer(accept: boolean) {
    setBusy(true);
    setError(null);
    try {
      if (accept) await api.acceptConnect(code);
      else await api.declineConnect(code);
      await refresh();
      setDone(accept ? "accepted" : "declined");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="account-page">
      <div className="page-head"><h1>{t.connect.title}</h1></div>
      <section className="card">
        {inviter === undefined && <p className="muted">{t.common.loading}</p>}
        {inviter === null && <p>{t.connect.gone}</p>}
        {inviter && !done && (
          <>
            <p>{t.connect.request(inviter.display_name)}</p>
            <p className="small muted">{t.connect.note}</p>
            <div className="chips">
              <button className="primary" disabled={busy} onClick={() => void answer(true)}>{t.connect.accept}</button>
              <button disabled={busy} onClick={() => void answer(false)}>{t.connect.decline}</button>
            </div>
          </>
        )}
        {inviter && done === "accepted" && <p>{t.connect.accepted(inviter.display_name)} <a href="/following" onClick={link("/following")}>{t.design.followingTitle}</a></p>}
        {done === "declined" && <p>{t.connect.declined}</p>}
        {error && <p className="error small">{error}</p>}
      </section>
    </div>
  );
}
